/**
 * Old plan IDs that need to be mapped to new active plans
 */
export enum OldPlanId {
  OUTREACH_STARTER_MONTHLY_OLD = 77,
  OUTREACH_PRO_MONTHLY_OLD = 78,
  OUTREACH_STARTER_YEARLY_OLD = 80,
  OUTREACH_PRO_YEARLY_OLD = 81,
}
